import React from "react";

import { SliderActions } from "@/common/Slider";
import Svg from "@/styles/Svg";

import { Content, Navigator, Title, Wrapper } from "./styles";

export type HeaderProps = {
  visible: boolean;
  navigation?: { previous: boolean; next: boolean; isSlideChanged?: boolean };
  onNavigationClick?: (
    event: React.MouseEvent<HTMLElement>,
    direction: SliderActions
  ) => void;
  icons?: IIcons;
};

export default class Header extends React.Component<HeaderProps> {
  constructor(props: HeaderProps) {
    super(props);
    this.handleOnPrevious = this.handleOnPrevious.bind(this);
    this.handleOnNext = this.handleOnNext.bind(this);
  }
  public render(): JSX.Element {
    const { visible, navigation, children, icons } = this.props;
    return (
      <Wrapper data-qa="header">
        <Content>
          <Navigator onClick={this.handleOnPrevious}>
            {navigation && navigation.previous && icons && (
              <Svg contents={icons.PageLeft} height={32} width={32} />
            )}
          </Navigator>
          <Title show={visible}>{children}</Title>
          <Navigator onClick={this.handleOnNext}>
            {navigation && navigation.next && icons && (
              <Svg contents={icons.PageRight} height={32} width={32} />
            )}
          </Navigator>
        </Content>
      </Wrapper>
    );
  }

  public handleOnPrevious(e: React.MouseEvent<HTMLElement>): void {
    const { navigation } = this.props;

    if (navigation && navigation.previous && this.props.onNavigationClick) {
      this.props.onNavigationClick(e, SliderActions.prev);
    }
  }

  public handleOnNext(e: React.MouseEvent<HTMLElement>): void {
    const { navigation } = this.props;

    if (navigation && navigation.next && this.props.onNavigationClick) {
      this.props.onNavigationClick(e, SliderActions.next);
    }
  }
}
